import React from "react";
import {
  Column,
  DataGrid,
  Paging,
  Pager,
  Selection,
  Lookup,
} from "devextreme-react/data-grid";
import UserInfo from "../UserInfo";
import uiInfo from "../ui-info";
import Form, { SimpleItem, Label } from "devextreme-react/form";
import { Button, ScrollView } from "devextreme-react";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import apiAxios from "../api-axios";
import notify from "devextreme/ui/notify";
import showError from "../AppServices";
import { criarAgentesRecebedoresDs, criarArquivosRetornoDs } from "../DataSources";

export default class ArquivosEBoletos extends React.Component {
  constructor() {
    super();

    this._gridInstance = React.createRef();
    this.arquivosDataSource = criarArquivosRetornoDs();
    this.bancosDataSource = criarAgentesRecebedoresDs();
    this.handleCarregar = this.handleCarregar.bind(this);
    this.handlePrintSelection = this.handlePrintSelection.bind(this);
    this.handlePrintClick = this.handlePrintClick.bind(this);
    this.handleConciliarRetorno = this.handleConciliarRetorno.bind(this);
    this.handleReprocessarArquivo = this.handleReprocessarArquivo.bind(this);

    this.state = {
      status: -1,
      tipoData: 1,
      dataInicio: new Date(),
      dataFinal: new Date(),
      arquivos: [],
      boletos: [],
      gridDisabled: false,
      popupVisivel: false,
      popupConciliarRetorno: false,
      arquivosIds: [],
    };
    this.tipoData = {
      editorType: "dxSelectBox",
      dataSource: [
        { id: 1, descricao: "IMPORTAÇÃO" },
        { id: 2, descricao: "GERAÇÃO" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };
    this.statusOptions = {
      editorType: "dxSelectBox",
      dataSource: [
        { id: -1, descricao: "TODOS" },
        { id: 0, descricao: "PENDENTE" },
        { id: 1, descricao: "FINALIZADO" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };
    this.bancoOptions = {
      editorType: "dxSelectBox",
      dataSource: this.bancosDataSource,
      valueExpr: "sequencial",
      displayExpr: "descricao",
      placeholder: " "
    };
  }

  async handleReprocessarArquivo(e) {

    try {
      await apiAxios.post(`arquivosretorno/reprocessar/${e.row.data.prefeituraId}/${e.row.data.id}`);
      notify("Reprocessamento solicitado com sucesso", "success");
    }
    catch (error) {
      notify(error, "error");
    }
  }

  async handleCarregar(e) {

    let filtro = [];
    let estado = this.state;

    if (estado.status != -1) {
      filtro.push(["status", "=", estado.status]);
    }

    if (estado.banco != undefined) {
      const codigoBanco = estado.banco.toString();
      filtro.push(["codigoDoBanco", "=", codigoBanco.padStart(3, "0")]);
    }

    if (estado.dam != null) {
      filtro.push(["sequencial", "=", estado.dam]);
    }

    const campoData = this.state.tipoData == 1 ? "dataImportacao" : "DataDeGeracaoDoArquivo";

    if (estado.dataInicio != null) {
      const data = estado.dataInicio;
      console.log(data);
      filtro.push([
        campoData,
        ">=",
        new Date(
          data.getFullYear(),
          data.getMonth(),
          data.getDate(),
          0,
          0,
          0,
          0
        ),
      ]);
    }

    if (estado.dataFinal != null) {
      const data = estado.dataFinal;
      console.log(data);
      filtro.push([
        campoData,
        "<=",
        new Date(
          data.getFullYear(),
          data.getMonth(),
          data.getDate(),
          23,
          5,
          59,
          999
        ),
      ]);
    }

  
    this._gridInstance.instance.beginUpdate();
    this._gridInstance.instance.clearFilter();
    this._gridInstance.instance.filter(filtro.length > 0 ? filtro : null);
    this._gridInstance.instance.endUpdate();

    this.setState({ boletos: [] });


    return;


    try {





      const response = await apiAxios.post(
        `/arquivosretorno/${UserInfo.getPrefeitura()}`,
        this.state
      );
      if (response.status === 200) {
        console.log(response);
        if (response.data.length === 0) {
          notify(
            "Não foi encontrado nenhum arquivo no intervalo de datas definido!",
            "warning",
            2000
          );
        }
        this.setState({ arquivos: response.data });
      }
    } catch (err) {
      showError(err.response.data);
      notify(err, "error", 2000);
    }
  }

  async handleSelection(selectedRowsData) {
    this.setState({ gridDisabled: true });
    try {
      const response = await apiAxios.get(
        `/arquivosretorno/${selectedRowsData[0].id}`
      );
      if (response.status === 200) {
        this.setState({ boletos: response.data, gridDisabled: false });
      }
    } catch (err) {
      console.log(err);
      showError(err.response.data);
      notify(err, "error", 2000);
    }
  }

  handlePrintSelection(rowKeys) {
    this.setState({ arquivosIds: rowKeys });
  }

  async handlePrintClick() {
    if (this.state.arquivosIds.length !== 0) {
      try {
        const formData = new FormData();
        formData.append("arquivosIds", this.state.arquivosIds);
        const response = await apiAxios.post(
          `/report/retornos/${UserInfo.getPrefeitura()}`,
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
        if (response.status === 200) {
          if (response.data.value.sucesso) {
            const bin = atob(response.data.value.report);
            const length = bin.length;
            const arrayBuffer = new ArrayBuffer(length);
            const uintArray = new Uint8Array(arrayBuffer);

            for (let i = 0; i < length; i++) {
              uintArray[i] = bin.charCodeAt(i);
            }

            const fileBlob = new Blob([uintArray], { type: "application/pdf" });
            const fileURL = URL.createObjectURL(fileBlob);

            window.open(fileURL, "_blank");
            return true;
          } else {
            notify("Relatório não encontrado.", "error");
            showError(response.data.value.erros);
            return false;
          }
        }
      } catch (err) {
        console.log(err);
        showError(err.response.data);
        notify(err, "error", 2000);
      }
    }
  }

  async handleConciliarRetorno(e) {
    apiAxios
      .post(`/dam/conciliar_retorno`, this.state)
      .then(() => {
        notify("Conciliação realizada, atualize a tela!", "success");
      })
      .catch((error) => {
        showError(error.response.data);
        notify(error, "error", 2000);
      });
  }

  async componentDidMount() {
    this.handleCarregar();
  }

  render() {
    return (
      <div className={"content-block dx-card responsive-paddings"}>
        <h3>Arquivos e Boletos</h3>
        <form>
          <Form formData={this.state} colCount={5}>
            <SimpleItem
              dataField={"tipoData"}
              editorOptions={this.tipoData}
              editorType={"dxSelectBox"}
              colSpan={1}
            >
              <Label text="Tipo de Data" />
            </SimpleItem>
            <SimpleItem
              dataField={"dataInicio"}
              editorOptions={{ width: "100%", useMaskBehavior: true }}
              editorType={"dxDateBox"}
              colSpan={1}
            >
              <Label text="Data Inicial" />
            </SimpleItem>
            <SimpleItem
              dataField={"dataFinal"}
              editorOptions={{ width: "100%", useMaskBehavior: true }}
              editorType={"dxDateBox"}
              colSpan={1}
            >
              <Label text="Data Final" />
            </SimpleItem>
            <SimpleItem
              dataField={"status"}
              editorOptions={this.statusOptions}
              editorType={"dxSelectBox"}
              colSpan={1}
            >
              <Label text="Status" />
            </SimpleItem>
            <SimpleItem
              dataField={"banco"}
              editorOptions={this.bancoOptions}
              editorType={"dxSelectBox"}
              colSpan={1}
            >
              <Label text="Banco" />
            </SimpleItem>
          </Form>
        </form>
        <br />
        <div
          style={{
            display: "flex",
            marginTop: "25px",
            justifyContent: "center",
            alignContent: "center",
            justifyItems: "center",
            alignItems: "center",
          }}
        >
          <Button
            type="success"
            text="Carregar"
            width={200}
            onClick={this.handleCarregar}
          />
          <Button
            className="side-to-side-button"
            text="Imprimir"
            width={200}
            onClick={() => this.setState({ popupVisivel: true })}

          />
          <Button className="side-to-side-button" text="Importar" width={200} />
        </div>
        <br />
        <div
          style={{
            display: 1 !== 0 ? "" : "none",
          }}
        >
          <h3>Lista de Arquivos</h3>
          <DataGrid
            ref={(grid) => (this._gridInstance = grid)}
            dataSource={this.arquivosDataSource}
            showBorders={true}
            rowAlternationEnabled={true}
            remoteOperations={true}
            focusedRowEnabled={true}
            columnAutoWidth={true}
            disabled={this.state.gridDisabled}
            loadPanel={{ enabled: true }}
            wordWrapEnabled={window.innerWidth < 800}
            key={"id"}
            keyExpr={"id"}
            onSelectionChanged={({ selectedRowsData }) =>
              this.handleSelection(selectedRowsData)
            }
          >
            <Selection mode="single" selectAllMode="allPages" />
            <Column
              width={50}
              type="buttons"
              fixed={true}
              fixedPosition={"left"}
              buttons={[
                {
                  hint: "Reprocessar",
                  icon: "redo",
                  onClick: this.handleReprocessarArquivo
                },
              ]}
            />
            <Column
              dataField={"id"}
              caption={"#"}
              width={"80"}
              allowEditing={false}
              alignment={"center"}
            />
            <Column
              dataField={"dataDeGeracaoDoArquivo"}
              caption={"Dt. Geração"}
              dataType={"date"}
              width={110}
              sortIndex={1}
              sortOrder={"desc"}
            />
            <Column
              dataField={"dataImportacao"}
              caption={"Dt. Importação"}
              dataType="date"
              width={130}
            />
            <Column dataField={"status"} caption={"Status"}>
              <Lookup
                dataSource={[
                  { id: 0, descricao: "Pendente" },
                  { id: 1, descricao: "Finalizado" },
                ]}
                valueExpr={"id"}
                displayExpr={"descricao"}
              />
            </Column>
            <Column dataField={"nsa"} caption={"Arquivo"} />

            <Column dataField={"nomeDoBanco"} caption={"Banco"} />
            <Column
              dataField={"totalRecebido"}
              caption={"Total Recebido"}
              dataType={"number"}
              format={uiInfo.formatoNumerico.n2}
            />
            <Column
              dataField={"totalBaixado"}
              caption={"Total Baixado"}
              dataType={"number"}
              format={uiInfo.formatoNumerico.n2}
            />
            <Column dataField={"codigoDoBanco"} caption={"Cód. Banco"} visible={false} />
            <Column
              dataField={"totalTarifas"}
              caption={"Total de Tarifas"}
              dataType={"number"}
              format={uiInfo.formatoNumerico.n2}
            />
            <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
            <Pager
              showPageSizeSelector={true}
              allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
            />
          </DataGrid>
        </div>
        <div
          style={{
            display: this.state.boletos.length !== 0 ? "" : "none",
          }}
        >
          <h3>Boletos</h3>
          <DataGrid
            dataSource={this.state.boletos}
            showBorders={true}
            rowAlternationEnabled={true}
            remoteOperations={true}
            focusedRowEnabled={true}
            columnAutoWidth={true}
            columnHidingEnabled={true}
            loadPanel={{ enabled: true }}
            wordWrapEnabled={window.innerWidth < 800}
            key={"nsa"}
            keyExpr={"nsa"}
          >
            <Column
              type="buttons"
              fixed={true}
              fixedPosition={"left"}
              caption="Serviços"
              buttons={[
                {
                  text: "Conciliar Retorno",
                  icon: "exportpdf",
                  onClick: (e) => {
                    console.log("data reg", e.row.data);
                    this.setState({
                      prefeituraId: UserInfo.getPrefeitura(),
                      arquivoId: e.row.data.retornoBancoId,
                      nsa: e.row.data.nsa,
                      damSequencial: e.row.data.damId,
                      dataPagamento: e.row.data.dataPagamento,
                      dataCredito: e.row.data.dataCredito,
                      valorRecebido: e.row.data.valorRecebido,
                      valorBaixado: e.row.data.valorBaixado,
                      agenciaContaEDigitoCreditada:
                        e.row.data.codigoAgenciaArrecadadora,
                      popupConciliarRetorno: true,
                    });
                  },
                },
              ]}
            />
            <Column dataField={"nsa"} caption={"Nsa"} alignment={"center"} />
            <Column dataField={"status"} caption={"Status"}>
              <Lookup
                dataSource={[
                  { id: 0, descricao: "Pendente" },
                  { id: 1, descricao: "OK" },
                  { id: 2, descricao: "Conciliado" },
                ]}
                valueExpr={"id"}
                displayExpr={"descricao"}
              />
            </Column>

            <Column dataField={"damId"} caption={"DAM"} />
            <Column
              dataField={"dataVencimento"}
              caption={"Dt. Vencimento"}
              dataType="date"
            />
            <Column
              dataField={"valorRecebido"}
              caption={"Valor Recebido"}
              dataType={"number"}
              format={uiInfo.formatoNumerico.n2}
            />
            <Column
              dataField={"valorBaixado"}
              caption={"Valor Baixado"}
              dataType={"number"}
              format={uiInfo.formatoNumerico.n2}
            />
            <Column
              dataField={"dataPagamento"}
              caption={"Dt. Pagamento"}
              dataType="date"
            />
            <Column
              dataField={"dataCredito"}
              caption={"Dt. Crédito"}
              dataType="date"
            />
            <Column
              dataField={"agenciaContaEDigitoCreditada"}
              caption={"Ag. Conta"}
            />
            <Column dataField={"serie"} caption={"Série"} />
            <Column dataField={"codigoBarras"} caption={"Código de Barras"} />
            <Column
              dataField={"codigoAgenciaArrecadadora"}
              caption={"Código da Agencia Arrecadadora"}
            />

            <Column
              dataField={"formaArrecadacao"}
              caption={"Forma de Arrecadação"}
            />
            <Column
              dataField={"numeroAutencicacao"}
              caption={"Número de Autenticação"}
            />

            <Column
              dataField={"registroArrecadacao"}
              caption={"Registro de Arrecadação"}
            />
            <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
            <Pager
              showPageSizeSelector={true}
              allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
            />
          </DataGrid>
        </div>
        <Popup
          visible={this.state.popupVisivel}
          onHiding={() => {
            this.setState({ popupVisivel: false });
          }}
          dragEnabled={false}
          closeOnOutsideClick={true}
          showCloseButton={true}
          showTitle={true}
          width={"90%"}
          height={"60%"}
          title="Imprimir Relatório de Arquivos"
        >
          <ScrollView showScrollbar="always">
            <h3>Lista de Arquivos</h3>
            <DataGrid
              dataSource={this._gridInstance.instance && this._gridInstance.instance.getDataSource().items()}
              showBorders={true}
              rowAlternationEnabled={true}
              remoteOperations={true}
              focusedRowEnabled={true}
              columnAutoWidth={true}
              columnHidingEnabled={true}
              disabled={this.state.gridDisabled}
              loadPanel={{ enabled: true }}
              wordWrapEnabled={window.innerWidth < 800}
              key={"id"}
              keyExpr={"id"}
              onSelectionChanged={({ selectedRowKeys }) =>
                this.handlePrintSelection(selectedRowKeys)
              }
            >
              <Selection
                mode="multiple"
                selectAllMode="allPages"
                showCheckBoxesMode="always"
              />
              <Column
                dataField={"id"}
                caption={"#"}
                width={"80"}
                allowEditing={false}
                alignment={"center"}
              />
              <Column
                dataField={"dataImportacao"}
                caption={"Data Importação"}
                dataType="date"
              />
              <Column dataField={"nomeDoArquivo"} caption={"Nome do Arquivo"} />
              <Column dataField={"status"} caption={"Status"}>
                <Lookup
                  dataSource={[
                    { id: 0, descricao: "Pendente" },
                    { id: 1, descricao: "Finalizado" },
                  ]}
                  valueExpr={"id"}
                  displayExpr={"descricao"}
                />
              </Column>
              <Column
                dataField={"codigoConvenio"}
                caption={"Código do Convênio"}
              />
              <Column dataField={"codigoDoBanco"} caption={"Código do Banco"} />
              <Column dataField={"nomeDoBanco"} caption={"Nome do Banco"} />
              <Column dataField={"totalRecebido"} caption={"Total Recebido"} />
              <Column dataField={"totalBaixado"} caption={"Total Baixado"} />
              <Column dataField={"totalTarifas"} caption={"Total de Tarifas"} />
              <Column
                dataField={"dataDeGeracaoDoArquivo"}
                caption={"Data de Geração do Arquivo"}
              />
              <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
              <Pager
                showPageSizeSelector={true}
                allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
              />
            </DataGrid>
          </ScrollView>
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Imprimir Relatório",
              type: "success",
              width: 150,
              onClick: this.handlePrintClick,
            }}
          />
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Fechar",
              type: "default",
              width: 150,
              onClick: () => this.setState({ popupVisivel: false }),
            }}
          />
        </Popup>
        <Popup
          visible={this.state.popupConciliarRetorno}
          onHiding={() => {
            this.setState({ popupConciliarRetorno: false });
          }}
          dragEnabled={false}
          closeOnOutsideClick={true}
          showCloseButton={true}
          showTitle={true}
          width={"500"}
          height={"600"}
          title="Conciliar Retorno"
        >
          {console.log(this.state)}
          <ScrollView showScrollbar="always">
            <Form formData={this.state} colCount={1} labelLocation="top">
              <SimpleItem dataField={"nsa"} editorOptions={{ readOnly: true }}>
                <Label text="Sequencial" />
              </SimpleItem>
              <SimpleItem
                dataField={"valorRecebido"}
                editorType={"dxNumberBox"}
                editorOptions={{
                  format: uiInfo.formatoNumerico.n2,
                  readOnly: true,
                }}
                cssClass={"txtNumerico"}
              >
                <Label text="Valor Recebido Banco (R$)" />
              </SimpleItem>
              <SimpleItem
                dataField={"damSequencial"}
                editorType={"dxNumberBox"}
              >
                <Label text="Nº DAM" />
              </SimpleItem>
              <SimpleItem
                dataField={"valorBaixado"}
                editorType={"dxNumberBox"}
                editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                cssClass={"txtNumerico"}
              >
                <Label text="Valor Baixado (R$)" />
              </SimpleItem>
              <SimpleItem
                dataField={"obs"}
                editorType={"dxTextArea"}
                editorOptions={{ height: "100px" }}
              >
                <Label text="Observação" />
              </SimpleItem>
            </Form>
          </ScrollView>
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Enviar",
              type: "success",
              width: 150,
              onClick: this.handleConciliarRetorno,
            }}
          />
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Fechar",
              type: "default",
              width: 150,
              onClick: () => this.setState({ popupConciliarRetorno: false }),
            }}
          />
        </Popup>
      </div>
    );
  }
}
